import styled from "styled-components/macro";
import { zIndexes } from "../../../utils";

export const LdsFacebookLoadingBar = styled.div(({ theme }) => ({
  display: "inline-block",
  position: "absolute",
  left: "8px",
  width: "16px",
  background: theme.color.brandPrimary.light,
  zIndex: zIndexes.widget + 12,
  animation: "lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite",
  "@keyframes lds-facebook": {
    "0%": {
      top: "8px",
      height: "64px",
    },
    "50%, 100%": {
      top: "24px",
      height: "32px",
    },
  },
}));
export const LdsFacebookLoading = styled.div({
  width: "80px",
  height: "80px",
  display: "inline-block",
  position: "relative",
  [`${LdsFacebookLoadingBar}:nth-child(1)`]: {
    left: "8px",
    animationDelay: "-0.24s",
  },
  [`${LdsFacebookLoadingBar}:nth-child(2)`]: {
    left: "32px",
    animationDelay: "-0.12s",
  },
  [`${LdsFacebookLoadingBar}:nth-child(3)`]: {
    left: "56px",
    animationDelay: "0",
  },
});

export const LdsFacebookContainer = styled.div({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: zIndexes.widget + 11,
});

export const LoadingGlass = styled.div({
  position: "absolute",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  zIndex: zIndexes.widget + 10,
});

export const LoadingContainer = styled.div({
  position: "relative",
  width: "100%",
});
